import yup from 'src/libraries/validator.library';
import {
  IFireAgencyForm,
  FireAgencyResponsePayloadSchema,
  FireAgencyListSchema,
} from 'src/models/fire-agency.model';
import { httpClient } from 'src/libraries/http.library';

const http = httpClient();

const services = {
  listGET: async () => {
    return http.get('fireAgencies', { limit: 0 }, FireAgencyListSchema);
  },
  updatePUT: async (id: number, data: IFireAgencyForm) => {
    return http.put(
      `fireAgencies/${id}`,
      data,
      FireAgencyResponsePayloadSchema
    );
  },
  addPOST: async (data: IFireAgencyForm) => {
    return http.post('fireAgencies', data, FireAgencyResponsePayloadSchema);
  },
  itemDELETE: async (id: number) => {
    return http.delete(`fireAgencies/${id}`, yup.mixed());
  },
};

export default services;
